import { useCookies } from 'react-cookie'

export const LIVE_MEETINGS_HIDE_VIDEO_COOKIE = 'hideLiveMeetingsVideoPopover'
export const LIVE_MEETINGS_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export const useLiveMeetingsFlags = () => {
  const [cookies] = useCookies()

  return {
    shouldShowLiveMeetingsVideo: !cookies[LIVE_MEETINGS_HIDE_VIDEO_COOKIE],
  }
}
